import { PriceLabel } from 'components';
import { numberWithCommas } from 'utility';

const columns = (currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه محصول',
    field: 'id',
    filtering: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام محصول',
    field: 'name',
    filtering: false,
    align: 'center',
  },
  {
    title: 'مجموع تعداد فروش - عدد',
    field: 'count',
    align: 'center',
    filtering: false,
    render: (rd) => (rd?.count != null ? numberWithCommas(rd?.count) : '-'),
  },
  {
    title: `مجموع مبلغ فروش - ${currencyText}`,
    field: 'income',
    align: 'center',
    filtering: false,
    render: (rd) => (rd?.income != null ? <PriceLabel amount={rd?.income} /> : '-'),
  },
];

const columnsId = {};
const orderingIndexes = [];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      id: row?.cols?.[0],
      name: row?.cols?.[1],
      count: row?.cols?.[2],
      income: row?.cols?.[3],
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
